export default __webpack_public_path__ + "static/house_2-ffd4b660b1865542d0f5ba3981b32328.png";